module.exports = __webpack_public_path__ + "static/media/1542318234488-98215848 - Citizen Datasteward.25a4bdf7.jpg";